import type { ButtonProps as RACButtonProps } from 'react-aria-components'
import { Button as RACButton, composeRenderProps } from 'react-aria-components'
import { focusRing } from '~/design-system/helpers'
import tv from '~/lib/tv'

// TODO: verificar para implementar completamente a parte de variant icon

export interface ButtonProps extends RACButtonProps {
  color?: 'primary' | 'secondary' | 'invisible'
  isOutlined?: boolean
  hasIcon?: boolean
  size?: 'sm'
}

let buttonVariants = tv({
  extend: focusRing,
  base: 'btn px-5 py-2 text-base font-medium text-center transition rounded-md border-black/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] cursor-pointer focus:outline-offset-4 outline-primary-light group ',
  variants: {
    color: {
      primary: 'bg-primary-orange text-white hover:bg-primary-medium pressed:bg-primary-orange',
      secondary: 'bg-primary-black text-white hover:bg-gray-80 pressed:bg-primary-black ',
      invisible: 'shadow-none border-none',
    },
    hasIcon: {
      true: 'btn-icon border-0 p-1 flex items-center justify-center text-gray-600 hover:bg-black/[5%] pressed:bg-black/10 disabled:bg-transparent',
    },
    isDisabled: {
      true: 'bg-gray-20 text-gray-40 forced-colors:text-[GrayText] border-black/5 cursor-not-allowed',
    },
    isOutlined: {
      true: 'border-2 bg-transparent',
    },
    size: {
      sm: 'px-3 py-1.5',
    },
  },
  compoundVariants: [
    {
      color: 'primary',
      isOutlined: true,
      class:
        'text-primary-orange hover:text-primary-medium hover:bg-primary-light pressed:bg-primary-light border-primary-orange hover:border-primary-medium',
    },
    {
      color: 'secondary',
      isOutlined: true,
      class: 'text-gray-100 hover:bg-gray-20 pressed:bg-gray-40 border-gray-40 hover:border-gray-100',
    },
    {
      isDisabled: true,
      isOutlined: true,
      class: 'text-gray-40 hover:bg-gray-20 pressed:bg-gray-40 border-gray-40 hover:border-gray-100',
    },
  ],
})

export { RACButton }

export default function Button(props: ButtonProps) {
  return (
    <RACButton
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        buttonVariants({
          ...renderProps,
          color: props.color,
          isOutlined: props.isOutlined,
          size: props.size,
          className,
        }),
      )}
    />
  )
}
